import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { filter, startWith, switchMap } from 'rxjs/operators';

import { injectRefetchListOrganizationsWithTotalsQuery } from '@models/organization/list-organizations-with-totals.query';

import { ChangeOrderSharedService } from '@shared/services/change-order-shared.service';
import { EventType, listUserNamesWithEmailQuery } from '@shared/services/gql.service';
import { AuthQuery } from '@shared/store/auth/auth.query';
import { MainQuery } from '@shared/store/main/main.query';
import { OrganizationService } from '@shared/store/organization/organization.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  selector: 'aux-budget-page',
  template: `
    <div class="mt-7">
      <router-outlet />
    </div>
  `,
})
export class BudgetPageComponent {
  authQuery = inject(AuthQuery);
  cdr = inject(ChangeDetectorRef);

  private changeOrderSharedService = inject(ChangeOrderSharedService);
  private mainQuery = inject(MainQuery);
  private organizationService = inject(OrganizationService);

  refetchListOrganizationsWithTotalsQuery = injectRefetchListOrganizationsWithTotalsQuery();

  numberOfChangeOrdersInPendingApproval$ = this.mainQuery.select('numberOfCOsInPendingApproval');

  constructor() {
    this.mainQuery
      .selectProcessingEvent(EventType.CHANGE_ORDER_BUDGET_TEMPLATE_UPLOADED)
      .pipe(
        startWith(false),
        filter((isUploaded) => isUploaded),
        switchMap(() => {
          this.refetchListOrganizationsWithTotalsQuery();

          return this.organizationService.getListWithTotalBudgetAmount();
        }),
        takeUntilDestroyed()
      )
      .subscribe();

    this.mainQuery
      .select('userList')
      .pipe(takeUntilDestroyed())
      .subscribe((_users) => {
        _users.forEach((user: listUserNamesWithEmailQuery) => {
          this.changeOrderSharedService.users.set(user.sub, user);
        });
      });
  }
}
